module.exports = __webpack_public_path__ + "static/media/Halloween_Too.68fb70b4.ttf";